export default (): boolean => {
    return !!document.querySelector('html')?.className?.match('translated');
};
